import { useEffect, useRef, useCallback } from 'react';
import { makeItineraryManagerApi } from 'services/ItineraryManagerApi';

const REFRESH_INTERVAL = 60000; // 1 min

interface IUseAccessUuidRefresherProps {
  accessUuid: string;
  itemUuid: string;
}

export function useAccessUuidRefresher({ accessUuid, itemUuid }: IUseAccessUuidRefresherProps) {
  const intervalIdRef = useRef<any>(null);
  const api = useRef(makeItineraryManagerApi()).current;

  const refreshAccess = useCallback(async () => {
    try {
      await api.refreshOtp(itemUuid, accessUuid);
    } catch (error) {
      if (error?.response?.status === 423) {
        window.location.reload();
      }
    }
  }, [api, itemUuid, accessUuid]);

  const startInterval = useCallback(() => {
    if (intervalIdRef.current) return;

    intervalIdRef.current = setInterval(() => {
      refreshAccess();
    }, REFRESH_INTERVAL);
  }, [refreshAccess]);

  const stopInterval = useCallback(() => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startInterval();
      } else {
        stopInterval();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    if (document.visibilityState === 'visible') {
      startInterval();
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      stopInterval();
    };
  }, [startInterval, stopInterval]);
}
